// a.k.a. collections (not the firebase ones).

import { DocumentData } from 'firebase/firestore';
import { GetQueryProps } from 'services/api/firestore';

export const CATEGORIES_COLLECTION_PATH = 'collections';
export const CG_CATEGORIES_COLLECTION_PATH = 'coloringGridCollections';

export const ALL_CATEGORIES_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: CATEGORIES_COLLECTION_PATH,
};

export const ALL_GRID_CATEGORIES_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: CG_CATEGORIES_COLLECTION_PATH,
};
